import React from 'react';
import { Navigate } from 'react-router-dom';
import CustomDesign from '../../../pages/CustomDesign';
import AIPhoneAssistantPage from '../../../pages/AIPhoneAssistantPage';
import BusinessPhone from '../../../pages/BusinessPhone';
import ClientPortals from '../../../pages/ClientPortals';
import WebApps from '../../../pages/WebApps';
import Rewards from '../../../pages/Rewards';
import SquareIntegrations from '../../../pages/SquareIntegrations';

/* The /services index was replaced by the six-pillar /solutions hub. The
   individual service pages stay live as the detail layer beneath a pillar
   (they are indexed and linked from the solution pages), so only the index
   itself redirects. */
export const servicesRoutes = [
  { path: '/services', element: <Navigate to="/solutions" replace /> },
  { path: '/services/custom-design', element: <CustomDesign /> },
  { path: '/services/ai-phone-assistant', element: <AIPhoneAssistantPage /> },
  { path: '/services/business-phone', element: <BusinessPhone /> },
  { path: '/services/client-portals', element: <ClientPortals /> },
  { path: '/services/web-apps', element: <WebApps /> },
  { path: '/services/rewards', element: <Rewards /> },
  { path: '/services/square-integrations', element: <SquareIntegrations /> }
];
